function loadScript(urls) {
  // Helper function to load a single script
  const loadSingleScript = url => {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = url;
      script.async = true;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  };

  // Handle both single URL (string) and multiple URLs (array)
  if (Array.isArray(urls)) {
    // Load multiple scripts and wait for all to complete
    return Promise.all(urls.map(url => loadSingleScript(url)));
  } else {
    // Load single script (backward compatibility)
    return loadSingleScript(urls);
  }
}

loadScript([
  'https://razorpay.com/build/razor-analytics/razorAnalytics-1.min.js',
  'https://razorpay.com/build/razor-analytics-plugins/razorAnalyticsPlugins-1.min.js'
])
  .then(initializeRazorAnalytics)
  .catch(error => {
    console.error('Failed to load analytics script:', error);
  });

function initializeRazorAnalytics() {
  try {
    const { lumberjack, segment } = window.razorAnalyticsPlugins;

    window.razorAnalytics.init({
      plugins: [
        lumberjack({
          transportConfig: {
            key: 'ezGnY9wN3IjNwgDM3MDMygzNwMTO04yy',
            appName: 'onboarding-new-events',
            url: 'https://lumberjack.razorpay.com/v1/track'
          }
        }),
        segment()
      ],
      mode: location.host === 'razorpay.com' ? 'live' : 'debug',
      eventProperties: {
        locale: 'IN',
        app: 'topf old-infra'
      },
      pageConfig: {
        captureSearchParams: true
      },
      autoCapture: {
        enabled: true,
        buttonClick: {
          captureTextContent: true
        },
        linkClick: {
          captureTextContent: true,
          captureSearchParams: true
        },
        scroll: {
          enabled: true
        }
      }
    });
  } catch (error) {
    console.error(error);
  }
}
